import { ViewModel,View } from "binder"
import  { FontWeightEditorView } from "./fontWeightEditor-view"
import { IStaticValueProvider } from "../IStaticValueProvider";

export class FontWeightEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.suggestions = [
            'bold',
            'bolder',
            'lighter',
            'normal',
            '100',
            '200',
            '300',
            '400',
            '500',
            '600',
            '700',
            '800',
            '900',
        ];
    }
    GetDefaultView(): View <ViewModel> {
        return new FontWeightEditorView();
    }
    public getTypeId(): string {
        return "VM-01D4C985-2894-42ED-BD5C-69F2BE97BA0A"
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];

    setValue(v: string) {
        this.value = v;
    }
    getValue(): string {
        return this.value;
    }

    requestConfirm() {
    }

}
